/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SurveyData = {
    properties: {
        id: {
    type: 'number',
},
        surveyId: {
    type: 'number',
},
        questionId: {
    type: 'number',
    isRequired: true,
},
        comment: {
    type: 'string',
},
        feedback: {
    type: 'string',
},
        ratingScore: {
    type: 'number',
    isRequired: true,
},
    },
};